"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidations = getValidations;
const formatFunctions_1 = require("../formatFunctions");
function getValidations(schema, validators, cache) {
    let funcs = cache ? validators._validationFunctions : undefined;
    if (funcs === undefined) {
        funcs = [];
        if (schema.type === 'array') {
            if (validators.minItems !== undefined) {
                funcs.push(_validations.minItems);
            }
            if (validators.maxItems !== undefined) {
                funcs.push(_validations.maxItems);
            }
        }
        else {
            if (schema.type === 'string') {
                if (validators.minimum !== undefined) {
                    if (String.prototype) {
                        funcs.push(_validations.minimumString);
                    }
                }
                if (validators.exclusiveMinimum !== undefined) {
                    // let nn: number = schema.exclusiveMinimum;
                    funcs.push(_validations.exclusiveMinimumString);
                }
                if (validators.maximum !== undefined) {
                    funcs.push(_validations.maximumString);
                }
                if (validators.exclusiveMaximum !== undefined) {
                    funcs.push(_validations.exclusiveMaximumString);
                }
                if (validators.maxLength !== undefined) {
                    funcs.push(_validations.maxLength);
                }
                if (validators.minLength !== undefined) {
                    funcs.push(_validations.minLength);
                }
                if (validators.pattern !== undefined) {
                    funcs.push(_validations.pattern);
                    /*
                    try {
                      let rg: RegExp;
                      if (validators.pattern instanceof RegExp) {
                        rg = validators.pattern;
                      } else {
                        rg = new RegExp(
                          validators.pattern || '',
                          validators.patternFlags === null ? '' : validators.patternFlags || 'i'
                        );
                      }
          
                      if (rg.flags.indexOf('g') > -1) {
                        funcs.push((value: string) => {
                          const res = rg.test(value) ? null : 'pattern';
                          rg.lastIndex = 0;
                          return res;
                        });
                      } else {
                        funcs.push((value: string) => (rg.test(value) ? null : 'pattern'));
                      }
                    } catch (err) {
                      if (defaultOptions.logErrors) {
                        console.error(`[DEBUG] get RegEx from "${validators.pattern}"`, err);
                      }
                      funcs.push(() => 'pattern');
                    }
                      */
                }
                if (validators.format !== undefined) {
                    // const ff = formatFunctions[schema.format];
                    // if (validators.format)
                    const ff = (0, formatFunctions_1.checkFormatFunction)(validators.format);
                    // console.log('get format function', schema.format, ff);
                    if (ff !== undefined) {
                        funcs.push((value /*, runschema: any*/) => (ff(value) ? null : 'format'));
                    }
                }
            }
            else {
                if (validators.minimum !== undefined) {
                    if (String.prototype) {
                        funcs.push(_validations.minimum);
                    }
                }
                if (validators.exclusiveMinimum !== undefined) {
                    // let nn: number = schema.exclusiveMinimum;
                    funcs.push(_validations.exclusiveMinimum);
                }
                if (validators.maximum !== undefined) {
                    funcs.push(_validations.maximum);
                }
                if (validators.exclusiveMaximum !== undefined) {
                    funcs.push(_validations.exclusiveMaximum);
                }
            }
            if (validators.enum !== undefined) {
                funcs.push(_validations.enum);
            }
            if (schema.type === 'number' || schema.type === 'integer' || schema.type === 'money') {
                if (validators.multipleOf) {
                    funcs.push(_validations.multipleOf);
                }
            }
        }
        if (cache) {
            Object.defineProperty(validators, '_validationFunctions', {
                enumerable: false,
                value: funcs
            });
        }
    }
    return funcs;
}
function _stringCompare(value, othervalue) {
    return value.toLocaleLowerCase().localeCompare(othervalue.toLocaleLowerCase());
}
const _validations = {
    enum(value, runschema) {
        const v = runschema.enum;
        if (v == null || v == undefined || v.indexOf(value) > -1)
            return null;
        return 'enum';
    },
    minItems(value, runschema) {
        const v = runschema.minItems;
        if (v == null || v == undefined || isNaN(v) || value.length >= v)
            return null;
        return 'minItems';
    },
    maxItems(value, runschema) {
        const v = runschema.maxItems;
        if (v == null || v == undefined || isNaN(v) || value.length <= v)
            return null;
        return 'maxItems';
    },
    multipleOf(value, runschema) {
        const v = runschema.multipleOf;
        if (v == null || v == undefined || isNaN(v) || value % v !== 0)
            return null;
        return 'multipleOf';
    },
    maxLength(value, runschema) {
        const v = runschema.maxLength;
        if (v == null || v == undefined || isNaN(v) || value.length <= v)
            return null;
        return 'maxLength';
    },
    minLength(value, runschema) {
        const v = runschema.minLength;
        if (v == null || v == undefined || isNaN(v) || value.length >= v)
            return null;
        return 'minLength';
    },
    minimum(value, runschema) {
        const v = runschema.minimum;
        if (v == null || v == undefined || isNaN(v) || value >= v)
            return null;
        return 'minimum';
    },
    exclusiveMinimum(value, runschema) {
        const v = runschema.exclusiveMinimum;
        if (v == null || v == undefined || isNaN(v) || value > v)
            return null;
        return 'exclusiveMinimum';
    },
    maximum(value, runschema) {
        const v = runschema.maximum;
        if (v == null || v == undefined || isNaN(v) || value <= v)
            return null;
        return 'maximum';
    },
    exclusiveMaximum(value, runschema) {
        const v = runschema.exclusiveMaximum;
        if (v == null || v == undefined || isNaN(v) || value < v)
            return null;
        return 'exclusiveMaximum';
    },
    minimumString(value, runschema) {
        const v = runschema.minimum;
        if (!v || _stringCompare(value, v) !== -1)
            return null;
        return 'minimum';
    },
    exclusiveMinimumString(value, runschema) {
        const v = runschema.exclusiveMinimum;
        if (!v || _stringCompare(value, v) === 1)
            return null;
        return 'exclusiveMinimum';
    },
    maximumString(value, runschema) {
        const v = runschema.maximum;
        if (!v || _stringCompare(value, v) !== 1)
            return null;
        return 'maximum';
    },
    exclusiveMaximumString(value, runschema) {
        const v = runschema.exclusiveMaximum;
        if (!v || _stringCompare(value, v) === -1)
            return null;
        return 'exclusiveMaximum';
    },
    pattern(value, runschema) {
        const v = runschema.pattern;
        if (v == null || v == undefined)
            return null;
        if (v.flags !== undefined) {
            v.lastIndex = 0;
            if (v.test(value))
                return null;
        }
        return 'pattern';
    }
};
//# sourceMappingURL=getValidations.js.map